import { render, staticRenderFns } from "./RingList.vue?vue&type=template&id=12fc53a4&scoped=true&"
import script from "./RingList.vue?vue&type=script&lang=js&"
export * from "./RingList.vue?vue&type=script&lang=js&"
import style0 from "./RingList.vue?vue&type=style&index=0&id=12fc53a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc53a4",
  null
  
)

export default component.exports